import { defineComponent as _defineComponent } from 'vue'
import sharedMessages from '@/lib/shared-messages';
import { defineMessages } from '@/lib/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'Enforce2FaConfirmDialog',
  props: {
    isOpen: { type: Boolean },
    isLoading: { type: Boolean }
  },
  emits: ["cancel", "confirm"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'cancel'): void;
  (e: 'confirm'): void;
}), expose: any, slots: any, attrs: any }) {





const m = defineMessages({
  confirmMessage:
    '今すぐ全ユーザーの二要素認証の利用を必須化してもよろしいですか？',
  announceTitle:
    '利用者に設定変更の告知をする場合は、管理者からお知らせする必要があります。',
  announceBody:
    'プロダクト内には、二要素認証の設定を促す通知が、利用していないユーザーに届きます。',
  logoutTitle: '認証設定をしていないユーザーは、強制的にログアウトされます。',
  logoutBody:
    '再度ログインする際に、認証設定をするよう要求されます。新規登録ユーザーも、ログインの際に認証設定が必要になります。',
  apply: '二要素認証を適用',
});

return { __sfc: true,emits, m, sharedMessages }
}

})